export default __webpack_public_path__ + "2f8fb0af53e155c3b9e837c0e8795901.jpg";